import { useEffect, useState } from 'react';
import { discoverTenantSupport } from '../../api/backendApi';

export function supportRowsFromResponse(response) {
  const rows = Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : []);
  return rows.filter((row) => row && row.tenantId);
}

export function useSupportAssignments(uid, dealerActive) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!uid || dealerActive) {
      setRows([]);
      return undefined;
    }
    let live = true;
    discoverTenantSupport()
      .then((response) => {
        if (live) setRows(supportRowsFromResponse(response));
      })
      .catch(() => {
        if (live) setRows([]);
      });
    return () => {
      live = false;
    };
  }, [uid, dealerActive]);

  return rows;
}
